// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";

import {
  passwordRequirements,
  validPasswordRegex,
} from "src/constants/password";
import {
  AuthForm,
  AuthFormHeader,
  InputAndLabelWrapper,
  FormLabel,
  InfoText,
  Button,
  ContainerLeftAligned,
} from "src/styles/auth";
import { Input, Text } from "@unifize/sarah";
import { resetPassword } from "src/actions/auth";
import { getSignInError, getSignInEmail } from "src/reducers";
import type { AppState, Location } from "src/types";
import NavLinks from "src/components/auth/NavLinks";
import * as colors from "src/styles/constants/colors";
import {
  SuccessMessageContainer,
  CircleCheckContainer,
} from "src/components/filter/Profile/styles";
import Icon from "src/icons";

type Props = {
  error: any,
  email: string,
  resetPassword: Function,
};

type State = {
  password: string,
};

class ResetPasswordComponent extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      password: "",
    };
  }

  handleChange(e: Object) {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  }

  handleSubmit(e: Object) {
    e.preventDefault();
    const { email } = this.props;
    const { password } = this.state;
    const { resetPassword } = this.props;
    resetPassword({ email, password });
  }

  render() {
    const { error } = this.props;
    const { password } = this.state;
    const { email } = this.props;
    const isValidPassword = validPasswordRegex.test(password);
    return (
      <Fragment>
        <AuthForm onSubmit={(e) => this.handleSubmit(e)}>
          <AuthFormHeader>{i18n.t(k.RESET_YOUR_PASSWORD)}</AuthFormHeader>
          <ContainerLeftAligned>
            <div>{i18n.t(k.YOU_HAVE_CLICKED_ON_A_PASSWORD)}</div>
            <b>{email}</b>
          </ContainerLeftAligned>
          <InputAndLabelWrapper>
            <FormLabel>
              <InfoText>{i18n.t(k.ENTER_A_NEW_PASSWORD)}</InfoText>
            </FormLabel>
            <Input
              autoFocus
              type="password"
              value={password}
              placeholder={i18n.t(k.NEW_PASSWORD_PLACEHOLDER)}
              name="password"
              onChange={(e) => this.handleChange(e)}
              required
              error={
                !isValidPassword && password.length
                  ? i18n.t(passwordRequirements)
                  : null
              }
            />

            {error && (
              <Text variant="caption" color={colors.redDark}>
                {error.message}
              </Text>
            )}
            {isValidPassword ? (
              <SuccessMessageContainer>
                <Text variant="caption" color={colors.greenDark}>
                  {i18n.t(passwordRequirements)}
                </Text>
                <CircleCheckContainer>
                  <Icon type="circleCheck" />
                </CircleCheckContainer>
              </SuccessMessageContainer>
            ) : null}
          </InputAndLabelWrapper>
          <Button type="submit" disabled={!isValidPassword}>
            {i18n.t(k.RESET_MY_PASSWORD)}
          </Button>
        </AuthForm>
        <NavLinks />
      </Fragment>
    );
  }
}

const mapStateToProps = ({ app }: { app: AppState, location: Location }) => ({
  error: getSignInError("resetPassword")(app),
  email: getSignInEmail(app),
});

const ResetPassword = connect(mapStateToProps, {
  resetPassword,
})(ResetPasswordComponent);

export default ResetPassword;
